// extracted by mini-css-extract-plugin
module.exports = {"carouselArrows":"carouselArrows_carouselArrows__Ypc26"};